// extracted by mini-css-extract-plugin
export default {"chip-list":"ChipList_chip-list__6WO1a"};